export default __webpack_public_path__ + "static/media/user.a80f0608.svg";